
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import CandidateV3Custom, {
  CandidateV3Item,
  CandidateGet,
  MDelete
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3";

@Component({
  components: {}
})
export default class AddCandidateTags extends Vue {
  @Prop() selectedItem!: CandidateV3Item;
  @Prop() selectedIdList!: number[];
  @Prop({ default: false }) visible!: boolean;
  @Prop() title!: string;
  @Prop() type!: string;

  singleParam = new CandidateGet();
  param = new MDelete();
  isAllowNotice = 0;
  isSingle = true;

  created() {
    this.isSingle = this.selectedIdList.length <= 1;
    console.log(this.selectedItem);
    this.isAllowNotice =
      this.selectedIdList.length === 1 ? this.selectedItem.messageStatus : 1;
    this.singleParam.candidateId = this.selectedItem.candidateId;
    this.param.candidateIdList = this.selectedIdList;
  }

  submit() {
    if (this.isSingle) {
      const env = this.title === "面试邀请通知" ? 1 : 10;
      CandidateV3Custom.sendAsk(this.singleParam, env)
        .then((resp: any) => {
          if (resp.code === 0) {
            this.$message.success("通知已发送，结果可以在消息通知列表查看");
          } else {
            this.$message.error(resp.message);
          }
          this.sure();
          this.cancel();
        })
        .catch(() => {
          this.cancel();
        });
    } else {
      const env = this.title === "面试邀请通知" ? 1 : 10;
      CandidateV3Custom.mSendAsk(this.param, env)
        .then((resp: any) => {
          if (resp.code === 0) {
            this.$message.success("通知已发送，结果可以在消息通知列表查看");
          } else {
            this.$message.error(resp.message);
          }
          this.sure();
          this.cancel();
        })
        .catch(() => {
          this.cancel();
        });
    }
  }

  @Emit()
  cancel() {
    return true;
  }

  @Emit()
  sure() {
    return true;
  }
}
